import { defineMessages } from 'react-intl-next';

export default defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.linkPickerButton.label',
		defaultMessage: 'Add link',
		description: 'Link picker button label within the Prompt screen',
	},
});
